import { render, staticRenderFns } from "./GridCell.vue?vue&type=template&id=2a3de08a&scoped=true&"
import script from "./GridCell.vue?vue&type=script&lang=js&"
export * from "./GridCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3de08a",
  null
  
)

export default component.exports